import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=e7335efe&scoped=true"
import script from "./VerifyPhone.vue?vue&type=script&lang=js"
export * from "./VerifyPhone.vue?vue&type=script&lang=js"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=e7335efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7335efe",
  null
  
)

export default component.exports